import { service } from '../../../service';

const getDefaultState = () => {
  return {
    loading: false,
  };
};

// initial state
const state = getDefaultState();

const actions = {
  resetState({ commit }) {
    commit('resetState');
  },
  async sendContact({ commit, dispatch, rootState }, { type, message }) {
    return service
      .post(`/help/contact`, {
        type,
        message,
        replyTo: rootState.account.user.email,
        company: rootState.account.company.companyName,
      })
      .then((result) => {
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const getters = {
  videos(state, getters) {
    return getters.guide.flatMap((g) => g.videos);
  },
  guide() {
    return [
      {
        title: 'Intro',
        id: 'intro',
        description:
          'Here you will find a selection of useful materials to help you get started or train a new member of staff.',
        videos: [],
      },
      {
        title: 'Planner',
        id: 'planner',
        description: 'See how the planner works',
        videos: [
          {
            category: 'Planner',
            title: 'Add jobs to the planner',
            src: 'https://player.vimeo.com/video/522275824',
            tags: ['setup', 'started'],
          },
          {
            category: 'Planner',
            title: 'Manage candidates availbility',
            src: 'https://player.vimeo.com/video/522276511',
            tags: ['setup', 'started'],
          },
          {
            category: 'Planner',
            title: 'Create client and candidate saved searches to save time',
            src: 'https://player.vimeo.com/video/522277248',
            tags: [],
          },
          {
            category: 'Planner',
            title: 'Start fulfilling jobs',
            src: 'https://player.vimeo.com/video/522277547',
            tags: [],
          },
          {
            category: 'Planner',
            title: 'Change shift status',
            src: 'https://player.vimeo.com/video/522278684',
            tags: [],
          },
          {
            category: 'Planner',
            title: 'Use the demo system to test',
            src: 'https://player.vimeo.com/video/522279697',
            tags: [],
          },
        ],
      },
    ];
  },
};

export const help = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
